// @ts-nocheck
import React from 'react'

const Select = ({ required, label, placeholder, element_option, onInputChange }) => {
    const handleInputChange = (event) => {
      onInputChange(label, event.target.value);
    };
  
    return (
      <div className="mb-6">
        <label className="mb-2 block text-sm font-semibold text-slate-800">
          <span data-i18n-ignore="true">{label}</span>
          {required && <span className="text-red-500"> *</span>}

        </label>
        <select
          id="options"
          className="block h-12 w-full rounded-xl border border-slate-300 bg-slate-50/60 px-4 text-sm text-slate-900 shadow-sm transition hover:border-slate-400 focus:border-emerald-600 focus:bg-white focus:outline-none focus:ring-4 focus:ring-emerald-100"
          onChange={handleInputChange}
        >
          <option disabled selected value="">
            Selecionar uma opção
          </option>
          {element_option.map((option) => (
            <option key={option} value={option} data-i18n-ignore="true">
              {option}
            </option>
          ))}
        </select>
      </div>
    );
  };

  export default Select;
